import { TableContainer, Box } from "@mui/material";
import styled from "styled-components";


export const TableContainerWrapper = styled(TableContainer)`
.taskrow{
    background-color:#BDD0E9;
    color: #1b4a83;
    text-align:center;
}
.tableContainer{
    table{
        border:1px solid #1B4A83;
     thead{
        background-color: #1B4A83;
       color:#BDD0E9;
        tr{
            th{
                color: #fff;
                font-weight: bold;
                text-align: start;
                padding:12px;
                    @media screen and (min-device-width: 1190px) and (max-device-width: 1288px) { 
                    font-size: 12px;
                    font-weight: 400;
                }
                .taskrow{
                    background-color:#BDD0E9;
                    color: #1b4a83;
                }
            }

            .css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon {
                opacity: 1;
                color: rgb(255, 255, 255);
            }

                .filterBar{
                    margin: -5px 8px;
                    font-size: 18px;
                        @media screen and (min-device-width: 1190px) and (max-device-width: 1288px) { 
    margin: -3px 8px;
 font-size: 16px;

 }
                }
            }
        }
     }
     tbody{
        tr{
            td{
                text-align: start;
                svg{

                }
            }
            th{

            }
        }
    }

}

}
`;


export const statusColors = {
    'Pending Approval': '#8A9123',
    'Pending Initial Requestor': '#E27900',
    'Approved': '#00AF97',
    'Submitted': '#239155',
    'Contracted': '#91238D',
    // Add more status values and colors as needed
  };